import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Toolbar } from '@mui/material';
import React, { useRef, useState } from 'react';
import { StyledAppBar } from './LayoutStyles';
import DrawerContent from './DrawerContent';
import LogoBig from '@images/logo-big.svg';
import { StyledIcon } from '@elements/icon/icon.styles';
import { IconButton, Typography } from '@elements';
import BurgerIcon from '@images/burger-icon.svg';
import Slider from 'react-slick';
import { MobileLayoutContext } from '../contexts/MobileLayoutContext';
import EditPersonalData from '@components/edit-personal-data/EditPersonalData';
import ChangeContacts from '@components/change-contacts/ChangeContacts';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var initialSliderContent = 'drawer';
var MobileLayout = function MobileLayout(_ref) {
  var children = _ref.children;
  var sliderRef = useRef(null);
  var _useState = useState(initialSliderContent),
    _useState2 = _slicedToArray(_useState, 2),
    sliderContent = _useState2[0],
    setSliderContent = _useState2[1];
  var handleNext = function handleNext(content) {
    setSliderContent(content);
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };
  var handlePrev = function handlePrev() {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };
  var sliderContentComponents = {
    drawer: /*#__PURE__*/_jsx(Box, {
      sx: {
        width: '100%',
        height: '100vh'
      },
      children: /*#__PURE__*/_jsx(DrawerContent, {
        handleDrawerClose: handlePrev,
        mobileOpen: true
      })
    }),
    editPersonalData: /*#__PURE__*/_jsx(Box, {
      sx: {
        px: '12px',
        pt: '12px'
      },
      children: /*#__PURE__*/_jsx(EditPersonalData, {
        handleClose: handlePrev
      })
    }),
    changeContacts: /*#__PURE__*/_jsx(Box, {
      sx: {
        px: '12px',
        pt: '12px'
      },
      children: /*#__PURE__*/_jsx(ChangeContacts, {
        handleClose: handlePrev
      })
    })
  };
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    swipe: false,
    arrows: false,
    ref: sliderRef,
    afterChange: function afterChange(change) {
      if (change === 0) {
        setSliderContent(initialSliderContent);
      }
    }
  };
  return /*#__PURE__*/_jsx(MobileLayoutContext.Provider, {
    value: {
      handleNext: handleNext,
      handlePrev: handlePrev
    },
    children: /*#__PURE__*/_jsxs(Slider, _objectSpread(_objectSpread({}, settings), {}, {
      children: [/*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            height: '100vh',
            overflow: 'auto'
          },
          children: [/*#__PURE__*/_jsx(StyledAppBar, {
            sx: {
              width: '100vw',
              py: 0
            },
            position: "fixed",
            elevation: 0,
            children: /*#__PURE__*/_jsxs(Toolbar, {
              sx: {
                justifyContent: 'space-between',
                minHeight: '50px !important'
              },
              disableGutters: true,
              children: [/*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: 'flex',
                  columnGap: '16px',
                  alignItems: 'center'
                },
                children: [/*#__PURE__*/_jsx(StyledIcon, {
                  src: LogoBig,
                  width: 38,
                  height: 38
                }), /*#__PURE__*/_jsx(Typography, {
                  color: "internationalOrange",
                  fontSize: 22,
                  children: "\u0425\u041A \u0410\u041C\u0423\u0420"
                })]
              }), /*#__PURE__*/_jsx(IconButton, {
                "aria-label": "open drawer",
                edge: "start",
                sx: {
                  display: {
                    md: 'none'
                  }
                },
                onClick: function onClick() {
                  return handleNext('drawer');
                },
                children: /*#__PURE__*/_jsx(StyledIcon, {
                  src: BurgerIcon,
                  width: 28,
                  height: 28
                })
              })]
            })
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              pt: '49px'
            },
            children: children
          })]
        })
      }), /*#__PURE__*/_jsx(Box, {
        children: sliderContentComponents[sliderContent]
      })]
    }))
  });
};
export default MobileLayout;